import { IColumnModel, ColumnModel } from 'table-editor';
import { Serializable, ISelectable } from 'starbase-launcher';

export class ImageDate implements Serializable<ImageDate>, ISelectable {
  public uid: number;
  public imageUID: number;
  public year: number;
  public month: number;
  public day: number;
  public quarter: number;
  public longMonthString: string;
  public selected = false;

  constructor(month: number) {
    this.month = month;
    this.longMonthString = this.longMonth();
    this.quarter = this.autoFillQtr(month);
  }

  public static imageDateColumnData(monthDropDownData: { txt: string, val: number }[]): IColumnModel[] {
    monthDropDownData.forEach(m => {
      m['longMonthString'] = m.txt;
    });
    return [
      new ColumnModel('UID', 'uid', 'UID', false, 'number', false, false, 10, false, null, null, 0),
      new ColumnModel('Image UID', 'imageUID', 'ImageUID', false, 'number', false, false, 10, false, null, null, 0),
      new ColumnModel('Year', 'year', 'Year', true, 'number', false, false, 20, true),
      new ColumnModel('Month', 'longMonthString', 'Month', false, 'dropdown', false, false, 12, true, monthDropDownData, 'longMonthString', null, null, null, null, false),
      new ColumnModel('Day', 'day', 'Day', true, 'number', false, false, 20, true)
    ];
  }
  public static imageDateWithQuarterColumnData(monthDropDownData: { txt: string, val: number }[]): IColumnModel[] {
    monthDropDownData.forEach(m => {
      m['longMonthString'] = m.txt;
    });
    return [
      new ColumnModel('UID', 'uid', 'UID', false, 'number', false, false, 10, false, null, null, 0),
      new ColumnModel('Image UID', 'imageUID', 'ImageUID', false, 'number', false, false, 10, false, null, null, 0),
      new ColumnModel('Year', 'year', 'Year', true, 'number', false, false, 20, true),
      new ColumnModel('Month', 'longMonthString', 'Month', false, 'dropdown', false, false, 12, true, monthDropDownData, 'longMonthString', null, null, null, null, false),
      new ColumnModel('Day', 'day', 'Day', true, 'number', false, false, 20, true),
      new ColumnModel('Quarter', 'quarter', 'Quarter', true, 'number', false, false, 1, true)
    ];
  }

  /** Outputs the long-form name a the month from the month number passed in. */
  public static longMonth(month: number): string {
    if (!month || isNaN(month) || month <= 0 || month > 12) {
      return '';
    }
    return new Date(month + '/1/1861').toLocaleDateString('en-us', { month: 'long' });
  }

  /** Get the month number from a month name.
   * @param monthText the month name to evaluate.
   * @returns the number value corresponding the month name or -1 if invalid.
   */
  public static convertToMonthNumber(monthText: string): number {
    const d = Date.parse(monthText + '1, 1865');
    if (!isNaN(d)) {
      return new Date(d).getMonth() + 1;
    }
    return -1;
  }
  /** Finds the appropriate quarter of the year based onthe month nubmer passed in.
   * @param month the number of the month of the year, 1-based  (Jan = 1).
   * @returns the quarter as a number
   */
  public static findQtrValue(month: number): number {
    if (month < 1) {
      return null;
    } else if (month <= 3) {
      return 1;
    } else if (month <= 6) {
      return 2;
    } else if (month <= 9) {
      return 3;
    } else if (month <= 12) {
      return 4;
    }
  }

  deserialize(input) {
    const d = Object.assign(new ImageDate(+input.month), input);
    d.longMonthString = d.longMonth();

    return d;
  }
  public longMonth(): string {
    // eslint-disable-next-line eqeqeq
    if (this.month == 0) {
      return '';
    }
    return new Date((+this.month).toString() + '/1/1861').toLocaleString('en-us', { month: 'long' });
  }

  /** Automatically selects and sets the appropriate quarter value to 'this' based on the month value passed in. */
  public autoFillQtr(month: number): number {
    if (month < 1) {
      return null;
    } else if (month <= 3) {
      this.quarter = 1;
      return 1;
    } else if (month <= 6) {
      this.quarter = 2;
      return 2;
    } else if (month <= 9) {
      this.quarter = 3;
      return 3;
    } else if (month <= 12) {
      this.quarter = 4;
      return 4;
    }
  }
}
